import { useQuery } from '@tanstack/react-query'
import { getMeFactorSettings, getFeatureFlags } from 'api/factors'
import { LS_FACTOR_SETTINGS } from 'constants/localStorageKeys'
import { qkGetFactorSettings, qkGetFeatureFlags } from 'constants/QueryKeys/factor'
import { booleanToString } from 'tools/common'

const useAdminSettings = () => {
  const { data: factorMeSettingResponse, refetch: refetchMeAdminSettings } = useQuery({
    queryKey: qkGetFactorSettings('me'),
    queryFn: () => {
      return getMeFactorSettings()
    },
    onSuccess: (data) => {
      //* Add settings to this object to save to local storage
      const settingsToLocalStorage = {
        enableCurrencySymbol: booleanToString(data.settings.enableCurrencySymbol),
      }
      localStorage.setItem(LS_FACTOR_SETTINGS, JSON.stringify(settingsToLocalStorage))
    },
  })

  const { data: featureFlagsResponse } = useQuery({
    queryKey: qkGetFeatureFlags(),
    queryFn: () => {
      return getFeatureFlags()
    },
  })

  const brightboltIntegration =
    featureFlagsResponse?.brightbolt.enabled && factorMeSettingResponse?.settings?.enableBrightboltIntegration

  return {
    chargeAccruedInterest: factorMeSettingResponse?.settings.chargeAccruedInterest,
    enableFuelAdvance: factorMeSettingResponse?.settings.enableFuelAdvance,
    flagEnableBrokerMod: featureFlagsResponse?.brokerMod.enabled,
    enableBrokerMod: factorMeSettingResponse?.settings.enableBrokerMod,
    factorFrequencyOfCollectionOfAccruedFees:
      factorMeSettingResponse?.settings.factorFrequencyOfCollectionOfAccruedFees,
    enableBrightboltIntegration: brightboltIntegration,
    hideAllChargebacks: featureFlagsResponse?.hideAllChargebacks.enabled,
    refetchMeAdminSettings: refetchMeAdminSettings,
    factorSetting: factorMeSettingResponse?.settings,
    exportLedgers: featureFlagsResponse?.exportLedgers.enabled || false,
    exportLedgersMaxRows: featureFlagsResponse?.exportLedgers.maxRows || 10,
    editPayment: featureFlagsResponse?.editPayment.enabled || false,
    enableNonFactoredInvoices: featureFlagsResponse?.nonFactoredInvoices.enabled || false,
    //enableNonFactoredInvoices: false,
    enableWithdrawPayment: featureFlagsResponse?.undoPayment.enabled || false,
    //enableWithdrawPayment: false,
    enableCreditCheck: featureFlagsResponse?.creditCheck.enabled || false,
    //enableCreditCheck: false,
    enableOutOfSystemInvoices: featureFlagsResponse?.outOfSystemInvoices.enabled || false,
    //enableOutOfSystemInvoices: false,
    enableReserveReleases: featureFlagsResponse?.reserveReleases.enabled || false,
    //enableReserveReleases: false,
    enableRebillInvoices: featureFlagsResponse?.rebillInvoices.enabled || false,
    //rebillInvoices: false,
    enableNoaLevelSetting: featureFlagsResponse?.noaLevelSetting.enabled || false,
    //enableNoaLevelSetting: false,
    noaLevelSetting: factorMeSettingResponse?.settings.noaLevelSetting,
    enableSplitPayments: featureFlagsResponse?.splitPayments.enabled || false,
    //enableSplitPayments: false,

    //enableAutomatedFunding: false,
    enableAutomatedFunding: featureFlagsResponse?.automatedFunding.enabled || false,
    enableInvoiceLineItem: factorMeSettingResponse?.settings.enableInvoiceLineItem,

    allowPaymentBackdating: factorMeSettingResponse?.settings.allowPaymentBackdating || false,
    enableNachaFile: factorMeSettingResponse?.settings.enableNachaFile || false,
    enableFactorAutoDraftPayments: factorMeSettingResponse?.settings.enableAutoDraftPayments || false,
    enableDocumentPaymentCreation: featureFlagsResponse?.automatedDraftPayments.enabled || false,
    //hideFundingChargebacks: false,
    hideFundingChargebacks: featureFlagsResponse?.hideFundingChargebacks.enabled || false,
    //enablePreferredPaymentChannel: false,
    enablePreferredPaymentChannel: featureFlagsResponse?.preferredPaymentChannel.enabled || false,
  }
}

export default useAdminSettings
